<template>
    <el-container>
        <el-header class="headview">
            <Topbar :isScroll="isScroll" class="topbar"></Topbar>
        </el-header>
        <el-container>
            <el-main id="main" ref="scrollBox">
                <router-view :key="$router.path"></router-view>
                <div class="foot-class">
                    <Footer class="footerclass"></Footer>
                </div>
                <toTop v-if="isScroll" @toTop="handleToTop"></toTop>
                <sidebar></sidebar>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Topbar from '@/components/Topbar.vue'
import Footer from '@/components/Footer.vue'
import toTop from '@/components/toTop.vue'
import sidebar from '@/components/sidebar.vue'
export default {
  data () {
    return {
      isScroll: false
    }
  },
  created () {
    document.title = 'GYPIC 全球青少年PBL创新素养大会'
  },
  mounted() {
    const el = document.querySelector('#main')
    if (el) {
      el.addEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    goTohome () {
      this.$router.push('/homeView')
    },
    handleToTop() {
      const scrollEle = document.querySelector('#main')
      // console.log(scrollEle.scrollTop)
      scrollEle.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll(event) {
      const target = event.target
      this.isScroll = target.scrollTop > 200
      // console.log('滚动位置：', target.scrollTop)
      // console.log('滚动事件：', event)
    }

  },
  components: {
    Topbar,
    Footer,
    toTop,
    sidebar
  }
}
</script>

<style lang="less" scoped>
.headview {
    width: 100vw;
    // background-color: #000;
    // position: relative;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
// .top-leftlogo {
//   widows: 120px;
//   height: 120px;
//   z-index: 100;
//   position: absolute; /*固定在顶部*/
//   top: 0;
//   left: 0px;
// }
// .top-leftlogo-image {
//   width: 70px;
//   height: 94px;
// }
.footerclass {
    // width: 1000px;
    width: 100%;
}
.el-main {
  width: 100%;
  padding: 0px !important;
  // overflow-y: scroll;
  // height: calc(100vh - 70px);
  height: 100vh;
  background-color: #eaeaea;
}
.el-main::-webkit-scrollbar {
    display: none;
}
.el-header {
    height: 70px !important;
    padding: 0;
}
.foot-class {
    width: 100vw;
    display: flex;
    // background-color: #d8d8d8;
    justify-content: center;
}
</style>
